import asyncComponent from '../common/utils/async-component.js';
import Logout from './components/logout/index.js';

const Login = asyncComponent(async () => import('./components/login/index.js'));
const LoginCliComplete = asyncComponent(async () => import('./components/login-cli-complete/index.js'));
const Signup = asyncComponent(async () => import('./components/signup/index.js'));
const ResetPassword = asyncComponent(async () => import('./components/reset-password.js'));
const ForgotPassword = asyncComponent(async () => import('./components/forgot-password/index.js'));
const CheckEmail = asyncComponent(async () => import('./components/check-email.js'));
const AccountSettings = asyncComponent(async () => import('./components/account-settings/index.js'));
const PersonalAccessTokens = asyncComponent(async () => import('./components/personal-access-tokens/index.js'));
const PersonalAccessTokenCreate = asyncComponent(
  async () => import('./components/personal-access-token-create/index.js')
);
const ValidateEmail = asyncComponent(async () => import('./components/validate-email/index.js'));

export default {
  '/login': {
    components: { topBar: null, main: Login }
  },
  '/login-cli-complete': {
    components: { main: LoginCliComplete }
  },
  '/logout': {
    components: { main: Logout }
  },
  '/signup': {
    components: { topBar: null, main: Signup }
  },
  '/reset-password': {
    components: { topBar: null, main: ResetPassword }
  },
  '/forgot-password': {
    components: { topBar: null, main: ForgotPassword }
  },
  '/check-email': {
    components: { topBar: null, main: CheckEmail }
  },
  '/account-settings': {
    components: { main: AccountSettings }
  },
  '/personal-access-tokens': {
    components: { main: PersonalAccessTokens },
    '/create': {
      components: { main: PersonalAccessTokenCreate }
    }
  },
  '/validate-email': {
    components: { main: ValidateEmail }
  }
};
